export const firstChatOpenUFOState: { hasOpenedChatInPageSession: boolean } = {
	hasOpenedChatInPageSession: false,
};
